/**
 * @generated SignedSource<<025b69f02aada4848876c14f76339f9e>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useItemShippingPrices_item$data = ReadonlyArray<{
  readonly isSold: boolean | null;
  readonly isUnavailable: boolean | null;
  readonly serviceId: string | null;
  readonly shipmentQuotes: ReadonlyArray<{
    readonly serviceMethod: {
      readonly region: {
        readonly code: string | null;
      } | null;
    } | null;
  } | null> | null;
  readonly " $fragmentType": "useItemShippingPrices_item";
}>;
export type useItemShippingPrices_item$key = ReadonlyArray<{
  readonly " $data"?: useItemShippingPrices_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"useItemShippingPrices_item">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "useItemShippingPrices_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isSold",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isUnavailable",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ShipmentQuote",
      "kind": "LinkedField",
      "name": "shipmentQuotes",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ShipmentServiceMethod",
          "kind": "LinkedField",
          "name": "serviceMethod",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Region",
              "kind": "LinkedField",
              "name": "region",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "code",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "0d5b529febcf8f2a7d8cd4c7477c5fbb";

export default node;
